import useTranslator from "../../../hooks/useTranslator";
import "./GridCardNew.css";

const GridCardNew = ({ index, title, value, icon, day }) => {
  const { _t } = useTranslator();

  return (
    <li key={index} className="grid_card d-block position-relative">
      <div className="gridcard_image position-absolute">
        <img src={icon} alt="total cases" />
      </div>
      <div className="gridcard_content">
        <span className="d-block total_count">
          {value?.total || 0}
        </span>
        <span className="total">
          {_t(title, title)}
        </span>
        <ul className="status_value ps-0 m-0">
          <li className="present">
            <span className="dot"></span>  <p className="m-0"> {_t("present", "Present")}:{" "}<span className="present_value"> {value?.present || 0} </span> </p>
          </li>
          <li className="absent">
            <span className="dot"></span>   <p className="m-0"> {_t("absent", "Absent")}:{" "}<span className="absent_value"> {value?.absent || 0} </span> </p>
          </li>
        </ul>
      </div>
    </li>
  );
};

export default GridCardNew;
